import { Box, Heading, SimpleGrid, Text } from '@chakra-ui/react';
import { approachSteps } from '../data/site';
import { Reveal } from './Section';
export function ApproachTimeline() {
  return <SimpleGrid columns={{
    base: 1,
    sm: 2,
    lg: 4
  }} spacing={0} borderTop="1px solid" borderColor="navy.200" data-id="element-21" data-mp="1adfzhv567k3b">
      {approachSteps.map((step, index) => <Reveal key={step.number} delay={index * 0.08} data-id="element-22" data-mp="10kh5fxqwn1cb" data-mpi={index}>
          <Box h="100%" pt={8} pb={10} px={{
        base: 0,
        lg: 8
      }} pl={{
        base: 0,
        lg: index === 0 ? 0 : 8
      }} borderLeft={{
        base: 'none',
        lg: index === 0 ? 'none' : '1px solid'
      }} borderColor="navy.100" position="relative" _before={{
        content: '""',
        position: 'absolute',
        top: '-1px',
        left: 0,
        w: '48px',
        h: '2px',
        bg: 'accent.500'
      }} data-id="element-23" data-mp="mmaez2oac3mo">
            <Text fontSize="sm" fontWeight={600} color="accent.600" letterSpacing="0.1em" mb={3} data-id="element-24" data-mp="2c05ssq82m2dn">
              {step.number} — {step.title}
            </Text>
            <Heading as="h3" fontSize="xl" mb={3} data-id="element-25" data-mp="1yzrv2n56dim7">
              {step.title}
            </Heading>
            <Text fontSize="sm" color="navy.500" lineHeight={1.8} data-id="element-26" data-mp="2do61t95ppr81">
              {step.short}
            </Text>
          </Box>
        </Reveal>)}
    </SimpleGrid>;
}